import PigRegistrationGroupApi from "@/api/pig-registration/PigRegistrationGroupApi";
export default {
  namespaced: true,
  state: {

  },
  mutations: {

  },
  actions: {
    async fetch() {
      try {
        const response = await PigRegistrationGroupApi.fetch();
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetchById(_, {id}) {
      try {
        const response = await PigRegistrationGroupApi.fetch(id);
        return Promise.resolve(response.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async addOrUpdate({dispatch}, {form}) {
      try {
        const response = await PigRegistrationGroupApi.addOrUpdate(form);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.save',
          { root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async delete({dispatch}, {id}) {
      try {
        const response = await PigRegistrationGroupApi.delete(id);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.save',
          { root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async move({dispatch}, form) {
      try {
        const response = await PigRegistrationGroupApi.move(form);
        dispatch('NOTIFY_MSG', 'pigRegistration.notification.save',
          { root: true});
        return Promise.resolve(response.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
